import { render } from "./TextMenuSet.vue?vue&type=template&id=704d22c9&scoped=true"
import script from "./TextMenuSet.vue?vue&type=script&lang=js"
export * from "./TextMenuSet.vue?vue&type=script&lang=js"

import "./TextMenuSet.vue?vue&type=style&index=0&id=704d22c9&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704d22c9"]])

export default __exports__